import {
  courseSectionsFetchFinished,
  getCourseSectionsFetchError,
  getCourseSectionsFetchStarted,
  getCourseSectionsFetchSuccess
} from "seneca-common/features/course/state";
import { useSelectorWithArgs } from "seneca-common/utils/hooks/selectors";

export default function useCourseSectionsFetchState(courseId: string) {
  return {
    coursesSectionsAreFetching: useSelectorWithArgs(
      getCourseSectionsFetchStarted,
      courseId
    ),
    coursesSectionsFetchSucceeded: useSelectorWithArgs(
      getCourseSectionsFetchSuccess,
      courseId
    ),
    coursesSectionsFetchErrored: useSelectorWithArgs(
      getCourseSectionsFetchError,
      courseId
    ),
    coursesSectionsFinishedFetching: useSelectorWithArgs(
      courseSectionsFetchFinished,
      courseId
    )
  };
}
